<template>
  <PlanSummaryCardText :title="planSummaryTitle" :pricing="planPricing" :subheading="subheading" :strikethroughPricing="strikethroughPricing" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
import { useCouponStore } from '@/store/CouponStore'

const checkoutStore = useCheckoutStore()
const priceStore = usePriceStore()
const productStore = useProductStore()
const couponStore = useCouponStore()

const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice, selectedPlanDisplayUnitPrice } = storeToRefs(priceStore)
const { hasAppliedCoupon } = storeToRefs(couponStore)

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)
const subheading = computed(() => `Lifetime access to ${productName.value}`)

const planPricing = computed(() => `${selectedPlanDisplayPrice.value} ${preTaxDetails.value}`)

const strikethroughPricing = computed(() => (hasAppliedCoupon.value ? selectedPlanDisplayUnitPrice.value : ''))
</script>
